import { supabase } from './supabase'

/**
 * Get backup configuration for organization
 */
export const getBackupConfiguration = async (organizationId) => {
  try {
    const { data, error } = await supabase
      .from('backup_configurations')
      .select('*')
      .eq('organization_id', organizationId)
      .single()

    if (error && error.code !== 'PGRST116') throw error
    return data || null
  } catch (error) {
    console.error('Error fetching backup configuration:', error)
    throw error
  }
}

/**
 * Get backup records for organization
 */
export const getBackupRecords = async (organizationId, filters = {}) => {
  try {
    let query = supabase
      .from('backup_records')
      .select('*')
      .eq('organization_id', organizationId)
      .order('started_at', { ascending: false })
      .limit(100)

    if (filters.status) {
      query = query.eq('status', filters.status)
    }
    if (filters.backupType) {
      query = query.eq('backup_type', filters.backupType)
    }

    const { data, error } = await query

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching backup records:', error)
    throw error
  }
}

/**
 * Trigger manual backup
 */
export const triggerManualBackup = async (organizationId) => {
  try {
    // This would typically trigger a server-side backup process
    // For now, we'll create a backup record
    const { data, error } = await supabase
      .from('backup_records')
      .insert({
        organization_id: organizationId,
        backup_type: 'full',
        status: 'in_progress',
        started_at: new Date().toISOString(),
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error triggering backup:', error)
    throw error
  }
}

/**
 * Get disaster recovery configuration
 */
export const getDisasterRecoveryConfig = async (organizationId) => {
  try {
    const { data, error } = await supabase
      .from('disaster_recovery_config')
      .select('*')
      .eq('organization_id', organizationId)
      .single()

    if (error && error.code !== 'PGRST116') throw error
    return data || null
  } catch (error) {
    console.error('Error fetching disaster recovery config:', error)
    throw error
  }
}

